import React,{Component,useState } from 'react';
import {Collapse,Container,Navbar,NavbarBrand,NavbarToggler,NavItem,NavLink,Dropdown,DropdownToggle,DropdownMenu,DropdownItem} from 'reactstrap';
import {Link} from 'react-router-dom';
import '../console.scss'

export class NavMenuLeft extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
      showSecond: 0,
      ToolsToggle:false,
      MasterToggle:false,
      pendingCount: 0,
      contactUnread: 0
    };
  }
componentDidMount(){
  let path = window.location.pathname;
  if(path=="/console/programmanagement"||path=="/console/programmanagement"){
    this.setState({ToolsToggle:true});
  }
  else{
    this.setState({ToolsToggle:false});
  }
  this.loadPending();
  this._pendingTimer = setInterval(() => this.loadPending(), 60000);
}
componentWillUnmount(){
  if (this._pendingTimer) clearInterval(this._pendingTimer);
}
loadPending(){
  fetch('api/grouprequest?status=pending')
    .then(r => r.ok ? r.json() : [])
    .then(list => this.setState({ pendingCount: list.length }))
    .catch(() => {});
  fetch('api/contact/count')
    .then(r => r.ok ? r.json() : { count: 0 })
    .then(d => this.setState({ contactUnread: d.count || 0 }))
    .catch(() => {});
}
  setDropdownOpen(t){
    var schema = {...this.state}
    schema[t] = !schema[t];;
    this.setState(schema)
  }

  render() {

  const {ToolsToggle, MasterToggle, pendingCount, contactUnread}= this.state;
  var role = (typeof localStorage !== 'undefined' && localStorage.getItem('role')) || '';
  var isAdmin = role === 'admin';

    return (
      <Navbar id="navbar-main" className={"navbar-expand-md navbar-toggleable-md ng-white mb-3 "} >
        <Container>
          <Collapse className="d-sm-inline-flex flex-sm-row-reverse " isOpen={!this.state.collapsed} navbar>
            <ul className="nav flex-grow" >
              <NavItem>
                <NavLink tag={Link} className="NavItemLeftLink" to="/console">
                  <i className="fas fa-tachometer-alt nav-icon"></i>
                  <span>Console home</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="NavItemLeftLink" to="/console/contact" style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <span><i className="fas fa-envelope-open-text nav-icon"></i>ข้อความติดต่อ</span>
                  {contactUnread > 0 && (
                    <span style={{ background:'#dc3545', color:'#fff', padding:'2px 10px', borderRadius:12, fontSize:11, fontWeight:700, minWidth:24, textAlign:'center' }}>
                      {contactUnread}
                    </span>
                  )}
                </NavLink>
              </NavItem>
              <Dropdown nav isOpen={ToolsToggle}  toggle={()=>true}>
                <DropdownToggle className="NavItemLeftLink" onClick={()=>this.setDropdownOpen("ToolsToggle")} nav caret>
                  <i className="fas fa-tools nav-icon"></i>
                  <span>Tools</span>
                </DropdownToggle>
                <DropdownMenu className="NavDropdownMenu">
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/programplus">
                  <i className="fas fa-globe-asia nav-subicon"></i>
                  <span>Program Plus</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/homeslide">
                  <i className="fas fa-images nav-subicon"></i>
                  <span>Slide หน้า Home</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/hashtag">
                  <i className="fas fa-hashtag nav-subicon"></i>
                  <span>Hashtag หน้าบ้าน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/tools/moment">
                  <i className="fas fa-camera nav-subicon"></i>
                  <span>ภาพประทับใจ</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/grouprequest" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:8 }}>
                  <span><i className="fas fa-users nav-subicon"></i>คำขอจัดกรุ๊ปส่วนตัว</span>
                  {pendingCount > 0 && (
                    <span style={{ background:'#dc3545', color:'#fff', padding:'2px 10px', borderRadius:12, fontSize:11, fontWeight:700, minWidth:24, textAlign:'center' }}>
                      {pendingCount}
                    </span>
                  )}
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Dropdown nav isOpen={MasterToggle} toggle={()=>true}>
                <DropdownToggle className="NavItemLeftLink" onClick={()=>this.setDropdownOpen("MasterToggle")} nav caret>
                  <i className="fas fa-layer-group nav-icon"></i>
                  <span>Master</span>
                </DropdownToggle>
                <DropdownMenu className="NavDropdownMenu">
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/highlights">
                  <i className="fas fa-star nav-subicon"></i>
                  <span>ทำไมต้องไปกับเรา?</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/icons">
                  <i className="fas fa-icons nav-subicon"></i>
                  <span>Icon ของวัน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/location">
                  <i className="fas fa-map-marked-alt nav-subicon"></i>
                  <span>ทวีป / ประเทศ / จังหวัด</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/airlines">
                  <i className="fas fa-plane nav-subicon"></i>
                  <span>สายการบิน</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/contactinfo">
                  <i className="fas fa-address-card nav-subicon"></i>
                  <span>ข้อมูลติดต่อ / Social</span>
                </DropdownItem>
                <DropdownItem tag={Link} className="NavSubItemLeftLink" to="/console/master/aboutus">
                  <i className="fas fa-info-circle nav-subicon"></i>
                  <span>เกี่ยวกับเรา</span>
                </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {isAdmin && (
                <>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/users">
                      <i className="fas fa-users-cog nav-icon"></i>
                      <span>จัดการ User</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/programlog">
                      <i className="fas fa-history nav-icon"></i>
                      <span>ประวัติการแก้ไข</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink tag={Link} className="NavItemLeftLink" to="/console/auditlog">
                      <i className="fas fa-user-shield nav-icon"></i>
                      <span>Login / การใช้งาน</span>
                    </NavLink>
                  </NavItem>
                </>
              )}
              <NavItem className="ml-auto">
                <NavLink className="NavItemLeftLink" href="#" onClick={(e) => { e.preventDefault(); localStorage.clear(); window.location.href = '/login'; }}>
                  <i className="fas fa-sign-out-alt nav-icon"></i>
                  <span>ออกจากระบบ</span>
                </NavLink>
              </NavItem>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}
